import { render, staticRenderFns } from "./DevelopmentStackSection.vue?vue&type=template&id=a36e8200&"
import script from "./DevelopmentStackSection.vue?vue&type=script&lang=js&"
export * from "./DevelopmentStackSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports